import { Languages } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '#/components/ui/dropdown-menu'
import { Button } from '#/components/ui/button'
import { getLocale, setLocale } from '#/paraglide/runtime'
import { m } from '#/paraglide/messages'
import { authClient, useHydratedSession } from '#/lib/auth-client'

const LABELS: Record<string, string> = { en: 'English', id: 'Bahasa Indonesia' }

export function LocaleToggle() {
  const current = getLocale()
  const { data } = useHydratedSession()
  const change = async (loc: 'en' | 'id') => {
    if (data?.user) {
      try {
        await authClient.updateUser({ locale: loc } as never)
      } catch {}
    }
    setLocale(loc)
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 gap-1.5 px-2 text-xs" aria-label={m.common_language()}>
          <Languages className="size-4" />
          <span className="uppercase">{current}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {(['en', 'id'] as const).map((l) => (
          <DropdownMenuItem key={l} onClick={() => change(l)} className={l === current ? 'font-semibold' : ''}>
            {LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
